<script>
  import { link } from "svelte-routing";
  import { BRAND } from "../../config";
  import PagesDropdown from "components/Dropdowns/PagesDropdown.svelte";

  let navbarOpen = false;

  function setNavbarOpen() {
    navbarOpen = !navbarOpen;
  }
</script>

<nav class="top-0 absolute z-50 w-full px-2 py-3 navbar-expand-lg">
  <div class="container mx-auto px-4 flex flex-wrap items-center justify-between">
    <div class="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
      <a
        use:link
        href="/"
        class="auth-nav-link text-white font-bold text-sm uppercase tracking-wide py-2"
      >
        {BRAND.name}
      </a>
      <button
        class="cursor-pointer text-xl leading-none px-3 py-1 rounded bg-transparent block lg:hidden outline-none focus:outline-none text-white"
        type="button"
        on:click={setNavbarOpen}
      >
        <i class="fas fa-bars"></i>
      </button>
    </div>

    <div
      class="lg:flex flex-grow items-center lg:bg-transparent rounded {navbarOpen ? 'block bg-white mt-3 p-2 shadow-lg' : 'hidden'}"
    >
      <ul class="flex flex-col lg:flex-row list-none mr-auto">
        <li class="flex items-center">
          <a
            class="auth-nav-link lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
            href="https://seraphsystems.com/nosotros"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="lg:text-blueGray-200 text-blueGray-400 far fa-file-alt text-lg leading-lg mr-2" />
            Nosotros
          </a>
        </li>
      </ul>
      <ul class="flex flex-col lg:flex-row list-none lg:ml-auto">
        <li class="flex items-center">
          <PagesDropdown />
        </li>
        <li class="flex items-center">
          <a
            class="auth-nav-link lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
            href="https://www.linkedin.com/company/seraph-systems-sa"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="lg:text-blueGray-200 text-blueGray-400 fab fa-linkedin text-lg leading-lg" />
            <span class="lg:hidden inline-block ml-2">LinkedIn</span>
          </a>
        </li>
        <li class="flex items-center">
          <a
            class="auth-nav-link lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
            href="https://seraphsystems.com/contactenos"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="lg:text-blueGray-200 text-blueGray-400 fas fa-envelope text-lg leading-lg" />
            <span class="lg:hidden inline-block ml-2">Contáctanos</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>

<style>
  :global(.auth-nav-link) {
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.65);
  }
</style>
